<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero.text-white
        span 6
      h1 Pasatiempos y <em>hobbies</em>
    p.mb-5(data-aos='fade-right') Cuando se habla de pasatiempos y hobbies en inglés, se debe tener en cuenta no solo el vocabulario, sino la forma en que se presentan dichas actividades. En inglés, no se muestra una actividad con el verbo TO BE, a menos que este verbo se encuentre en forma ING.
      br
      br
      |Ahora, revisemos el vocabulario para que memorice y practique:
    SlyderF.mb-5(columnas="col-lg-6 col-xl-3")
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/169.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic  Watch TV
          p.mb-0 Ver televisión  
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/170.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Go out with friends 
          p.mb-0 Salir con amigos
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/171.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Play video games
          p.mb-0 Jugar videojuegos
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/172.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Play tennis
          p.mb-0 Jugar tenis
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/173.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Play soccer/football
          p.mb-0 Jugar fútbol
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/174.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Read 
          p.mb-0 Leer
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/175.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Listen to music
          p.mb-0 Escuchar musica
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/176.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Surf the internet

          p.mb-0 Navegar en internet
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/177.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Go shopping
          p.mb-0 Ir de compras
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/178.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Go to the cinema 
          p.mb-0 Ir al cine 
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/179.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Do yoga 

          p.mb-0 Hacer yoga
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/180.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Cycling
          p.mb-0 Hacer ciclismo
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/181.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Hiking
          p.mb-0 Hacer senderismo
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/182.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Exercise
          p.mb-0 Hacer ejercicio
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/183.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Cook 
          p.mb-0 Cocinar
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/184.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Dance
          p.mb-0 Bailar
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/185.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic  Take photos
          p.mb-0 Tomar fotos
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/186.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Draw 
          p.mb-0 Dibujar
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/187.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic  Text 
          p.mb-0 Enviar mensajes de texto
      .tarjeta.no-repeat.d-flex.align-items-end.justify-content-center(:style="{'background-image': `url(${require('@/assets/curso/temas/188.jpg')})`}" style='height: 394px').p-4
        .tarjeta.bg-white.mw.p-4.text-center
          h4
            span.r-3.fst-italic Sing 
          p.mb-0 Cantar
    .tarjeta.p-4.d-flex.align-items-center(style='background-color: #ffdfe0').mb-4
      Audio.color-acento-contenido.mx-3(:audio="require('@/assets/curso/audio/tema6/1.mp3')").me-4
      p.mb-0 Ahora escucha, repite y revisa de nuevo el vocabulario: 
    h5 ¿Cómo usar las actividades según la expresión?
    p.mb-5(data-aos='fade-right')  Ahora, cada una de las actividades puede usarse de acuerdo con la expresión. Revisemos: 
    TabsB.color-secundario.mb-5
      .row.p-3(titulo="Case 1" :icono="require('@/assets/curso/temas/192.svg')" style='background-color= #e1e8fe !important') 
        .col-lg-3.col-8.mb-lg-0.mb-3: img.mb-5(src='@/assets/curso/temas/189.svg', alt='')
        .col-lg-9
          .tarjeta.bg-white.p-4
            h5 Case 1
            p En caso de ser presentados como verbos principales de la oración, se conjugan según el tiempo.
              br
              br
              span.fst-italic.fw-bold For example: 
            .row.justify-content-center
              .col-lg-6.mb-lg-0.mb-3
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I do yoga with my friends. "
                :audio="require('@/assets/curso/audio/tema6/1.mp3')"
                )
                p Yo hago yoga con mis amigos.
              .col-lg-6
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="We take photos on our trips. "
                :audio="require('@/assets/curso/audio/tema6/2.mp3')"
                )
                p Nosotros tomamos fotos en nuestros viajes.
      .row.p-3(titulo="Case 2" :icono="require('@/assets/curso/temas/193.svg')" style='background-color= #e1e8fe !important') 
        .col-lg-3.col-8.mb-lg-0.mb-3: img.mb-5(src='@/assets/curso/temas/190.svg', alt='')
        .col-lg-9
          .tarjeta.bg-white.p-4
            h5 Case 2
            p En caso de ser presentado como un hobby, después del verbo TO BE, se debe mostrar con la terminación -ing.
              br
              br
              span.fst-italic.fw-bold For example: 
            .row.justify-content-center
             
              .col-lg-6.mb-lg-0.mb-3
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="My favorite hobby is doing yoga."
                :audio="require('@/assets/curso/audio/tema6/3.mp3')"
                )
                p Mi pasatiempo favorito es hacer yoga.
              .col-lg-6
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="My favorite activities are singing, taking photos and texting."
                :audio="require('@/assets/curso/audio/tema6/4.mp3')"
                )
                p Mis actividades favoritas son cantar, tomar fotos y enviar mensajes de texto.
      .row.p-3(titulo="Case 3" :icono="require('@/assets/curso/temas/194.svg')" style='background-color= #e1e8fe !important') 
        .col-lg-3.col-8.mb-lg-0.mb-3: img.mb-5(src='@/assets/curso/temas/191.svg', alt='')
        .col-lg-9
          .tarjeta.bg-white.p-4
            h5 Case 3
            p En caso de mostrarlo después del verbo LIKE o LOVE, los verbos se deben usar con la preposición TO.
              br
              br
              span.fst-italic.fw-bold For example:
            .row.justify-content-center
              .col-lg-6.mb-lg-0.mb-3
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="I like to play video games."
                :audio="require('@/assets/curso/audio/tema6/5.mp3')"
                )
                p  Me gusta jugar videojuegos.
              .col-lg-6
                TarjetaAudio.color-acento-contenido.bg-white.mb-3(
                texto="We love to sing."
                :audio="require('@/assets/curso/audio/tema6/w1.mp3')"
                )
                p Nos encanta cantar.
    titulo-segundo.color-acento-contenido(data-aos='fade-right')
      h2 Actividad didáctica
    .row.mb-5.justify-content-center.align-items-center.align-items-lg-stretch
      .col-6.col-md-4.col-lg-3.mb-4.mb-md-0
        .tarjeta.h-100.d-flex.align-items-center.p-4
          figure
            img(src="@/assets/template/completar.svg", alt="Texto que describa la imagen")
      .col-12.col-md-8.col-lg-9
        .titulo-segundo
          h2 <em>In my free time I...</em> / En mi tiempo libre yo...
        p.mb-4 Reforzar el conocimiento sobre la forma en que se presentan las actividades y su expresión.
        .tarjeta.actividad.p-3
          .row.justify-content-around.align-items-center            
            .col-sm.mb-3.mb-sm-0
              p.fw-bold.mb-0 Banco de palabras.
            .col-auto
              a.boton.boton--b(:href="obtenerLink('/actividades/actividad6/story.html')" target="_blank")
                span Realizar
                i.fas.fa-puzzle-piece







</template>

<script>
export default {
  name: 'Tema4',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass">
.img-infografica-b__modal__contenido div
  color: $color-acento-contenido !important
.card-title
  width: 100%
  display: block
  position: relative
  background-color: #ffdfe0
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out
  &:hover
    background-color: $color-secundario
    p
      color: $white
  .card-title__div
    position: absolute
    width: 100%
    top: 0
    left: 0
    transform: translateY(-30%)
    display: flex
    justify-content: center
    .card-title__div-title
      background-color: $color-acento-contenido
      h6
        color: #fff
      display: block
.no-repeat
  background-size: cover
  background-position: center
  background-repeat: no-repeat
  height: 100%
  width: 100%
  position: relative
.slyder-f__btn
  .fa-chevron-right:before
    content: url('../assets/curso/temas/iz.svg') !important
  .fa-chevron-left:before
    content: url('../assets/curso/temas/dr.svg') !important
.tabs-b__tab--active
  background-color: #e1e8fe
.tabs-b__content-item
  background-color: #e1e8fe
</style>
